<template>
	<!-- User Identity Verification -->
	<modal
		class="verification-modal"
		@close="close"
        :size='"medium"'>
		<template slot="header">
			<h3><b>{{ $t('User Identity Verification') }}</b></h3>
		</template>
		<template slot="body">
			<div class="form-group">
				<label><b>{{ $t('Name') }}</b></label>
				<input type="text" class="form-control" disabled v-model="user.name">
			</div>
			<div class="form-group">
				<label><b>{{ $t('Selfie With Identity') }}</b></label>
				<div class="my-2 text-center preview-image" v-if="previewImageSelfie !== ''">
					<img class="img-fluid rounded" style="max-height: 200px;" :src="previewImageSelfie" alt="Identity Image">
				</div>
				<div class="my-2" v-else>
					<div class="alert alert-warning">
						User not uploading a photo selfie with identity
					</div>
				</div>
			</div>
			<div class="form-group">
				<label><b>{{ $t('Identity Image') }}</b></label>
				<div class="my-2 text-center preview-image" v-if="previewImageFull !== ''">
					<img class="img-fluid rounded" style="max-height: 200px;" :src="previewImageFull" alt="Identity Image">
				</div>
				<div class="my-2" v-else>
					<div class="alert alert-warning">
						User not uploading a photo of identity
					</div>
				</div>
			</div>
			<div class="form-group">
				<label><b>{{ $t('Identity Number') }}</b></label>
                <input type="text" class="form-control" v-model="identityNumber">
			</div>
            <div class="form-group">
                <label><b>Status Verification</b></label>
                <select class="form-control" v-model="identityStatus">
                    <option value="requested">Requested</option>
                    <option value="skipped" disabled>Skipped</option>
                    <option value="rejected">Rejected</option>
                    <option value="approved">Approved</option>
                </select>
            </div>
			<div class="form-group" v-if="identityStatus == 'rejected'">
				<label><b>{{ $t('Reject Note') }}</b></label>
                <textarea class="form-control" v-model="identityRejectNote"/>
			</div>
		</template>
		<template slot="footer">
			<button
				v-if="source === 'supplier-profile' || source === 'seller-profile'"
				class="btn btn-light"
				@click="back">
					{{ $t('Back') }}
			</button>
			<button
				v-else
				class="btn btn-light"
				@click="close">
					{{ $t('Close') }}
			</button>
			<button
				class="btn btn-primary"
				:class="{ 'is-loading': isUpdating }"
				@click="updateIdentityCard"
			>
				{{ $t('Save') }}
			</button>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import userApi from '../api/user';
// import { generateWaUrl } from '@/lib/helper';

export default {
	name: 'ModalUserVerification',
	components: {
		Modal,
	},
	props: {
		user: {
			type: Object,
			default: null,
		},
		source: {
			type: String,
			default: 'direct', // direct, supplier-profile, seller-profile
		},
	},
	data() {
		return {
			identityStatus: 'requested',
			identityNumber: '',
			identityRejectNote: '',
			previewImageSelfie: '',
			previewImageFull: '',
			identity: null,
			isUpdating: false,
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		back() {
			if (this.source === 'supplier-profile') {
				this.$emit('back-supplier', this.user);
			} else {
				this.$emit('back-seller', this.user);
			}
		},
		updateIdentityCard() {
			this.isUpdating = true;
			const identity = this.identity || {
				type: '',
				image_url: '',
				image_url_full: '',
			};

			identity.status = this.identityStatus;
			identity.number = this.identityNumber;
			identity.reject_note = this.identityRejectNote;

			const params = {
				identity: JSON.stringify(identity),
				user_id: this.user._id,
			};

			const callback = () => {
				this.isUpdating = false;
				this.$emit('update', {
					...identity,
					user_id: this.user._id,
				});
				this.close();
			};
			const errorCallback = (error) => {
				this.isUpdating = false;
				console.log(error);
			};
			userApi.updateIdentityCardByAdmin(params, callback, errorCallback);
		},
	},
	mounted() {
		if (this.user !== null && this.user.identity !== undefined) {
			this.identity = this.user.identity;
			this.previewImageSelfie = this.identity?.image_url ?? '';
			this.previewImageFull = this.identity?.image_url_full ?? '';
			this.identityNumber = this.identity.number;
			this.identityStatus = this.identity.status;
			this.identityRejectNote = this.identity.reject_note;
		}
	},
	computed: {
	},
};
</script>
